import { useState } from 'react'
import type { Role } from '../types'
import { RoleFormDialog } from './RoleFormDialog'

export function GeneralPanel({ role }: { role: Role }) {
  const [editing, setEditing] = useState(false)
  return (
    <div className="flex flex-col gap-2 text-sm max-w-md">
      <div><span className="text-xs uppercase text-slate-500">Kod:</span> <span className="font-mono">{role.code}</span></div>
      <div><span className="text-xs uppercase text-slate-500">Nazwa:</span> {role.name}</div>
      <div><span className="text-xs uppercase text-slate-500">Opis:</span> {role.description ?? '—'}</div>
      <div><span className="text-xs uppercase text-slate-500">Aktywna:</span> {role.isActive ? 'tak' : 'nie'}</div>
      <button
        type="button"
        onClick={() => setEditing(true)}
        className="self-start mt-2 px-3 py-1.5 bg-sky-600 text-white rounded text-sm"
      >Edytuj</button>

      {editing && <RoleFormDialog editing={role} onClose={() => setEditing(false)} />}
    </div>
  )
}
